module.exports = __webpack_public_path__ + "static/media/compile.9d580577.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/compile.svg
// module id = 586
// module chunks = 1